<template>
    <div class=''>
        <a-drawer
            :title="title"
            placement="right"
            :width="width"
            :visible="visible"
            @close="onClose"
        >
            <a-descriptions bordered size="small" :column="1" class="descriptions-box">
                <a-descriptions-item v-for="(item, index) of columns" :key="index" :label="item.title">
                    <template v-if="item.type == 'arr'">
                        <div v-for="(k, j) in rowData[item.value]">
                            {{ k }}
                        </div>
                    </template>
                    <template v-else-if="item.type == 'time'">
                        {{ rowData[item.value] ? moment(rowData[item.value] * 1000).format('YYYY-MM-DD HH:mm:ss') : null }}
                    </template>
                    <template v-else-if="item.type == 'timeMilli'">
                        {{ rowData[item.value] ? moment(rowData[item.value]).format('YYYY-MM-DD HH:mm:ss.SSS') : null }}
                    </template>
                    <!-- 过滤状态等 -->
                    <template v-else-if="item.type == 'filter'">
                        {{ filterData(rowData[item.value], item.data) }}
                    </template>
                    <template v-else>
                        {{ rowData[item.value] }}
                    </template>
                </a-descriptions-item>
            </a-descriptions>
        </a-drawer>
    </div>
</template>

<script>
import moment from 'moment';
let self;
export default {
    data() {
        return {
            moment,
        };
    },
    props: {
        title: String,
        visible: Boolean,
        width: {
            type: Number,
            default: 750
        },
        columns: Array,
        rowData: Object
    },
    created() {
        self = this
    },
    methods: {
        onClose() {
            this.$emit("onClose")
        },
        filterData(key, data) {
            for(let item of data) {
                if(item.key == key) {
                    return item.value
                }
            }
            return ""
        }
    },
}
</script>

<style lang='scss' scoped>
.descriptions-box ::v-deep .ant-descriptions-row {
    display: flex;
    .ant-descriptions-item-label {
        min-width: 150px;
        width: 150px;
        display: flex;
        align-items: center;
    }
}
</style>
